import * as actionTypes from './UsersActions';
import axios from 'axios';
import { backend_server_address } from '../../../backendServer';

export const userGetListStart = () => {
    return {
        type: actionTypes.USERS_GET_LIST_START,
        loading: true,
    };
};

export const userGetListSuccess = (users) => {
    return {
        type: actionTypes.USERS_GET_LIST_SUCCESS,
        userList: users,
        loading: false,
    };
};

export const userGetListFail = (error) => {
    return {
        type: actionTypes.USERS_GET_LIST_FAIL,
        error: error,
        loading: false,
    };
};

export const userGetList = () => (dispatch) => {
    dispatch(userGetListStart());
    axios
        .get(backend_server_address + '/api/login/user/', {
            withCredentials: true,
        })
        .then((res) => {
            dispatch(userGetListSuccess(res.data));
        })
        .catch((error) => {
            dispatch(userGetListFail(error));
        });
};
